import { createAction } from '@reduxjs/toolkit';

export const addWithdrawal = createAction<object>('finance/addWithdrawal');
export const resetWithdrawalError = createAction(
  'finance/resetWithdrawalError'
);
export const setWithdrawalLoading = createAction('finance/setLoading');
